import { useRef, useState } from 'react';

/** Guard before React renders, including repeated keyboard activation in one tick. */
export function useStateAction() {
  const lock = useRef(false);
  const [pending, setPending] = useState(false);
  const [failed, setFailed] = useState(false);
  async function run(action?: () => void | Promise<unknown>) {
    if (!action || lock.current) return;
    lock.current = true;
    setPending(true);
    setFailed(false);
    try {
      await action();
    } catch {
      // Domain owners render detailed failures; never expose raw provider errors.
      setFailed(true);
    } finally {
      lock.current = false;
      setPending(false);
    }
  }
  return { run, pending, failed };
}
